import { formatPrice } from "utils";
import BudgetInformation from "./BudgetInformation";
import { getOnlyNumbers } from "client/utils/RequisitionUtil";

const logoedOption = [
    { value: '', label: 'Select Logoed' },
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' }
];

const BudgetInformationContainer = (props: any) => {
    const {
        assetTypeValue,
        budgetPercentList,
        useFulLifeList,
        catalogItemValues,
        setCatalogItemValues,
        catalogItemErrors,
        validateCatalogItemValues,
        setCatalogItemErrors,
        getGLCode,
        useList,
        onPopupFilterModel
    } = props

    const getMonthlyDeprecation = (name: any, val: any, budgetPrice: any) => {
        if (val == 0 || budgetPrice == 0 || val?.label == 0) {
            setCatalogItemValues((prev: any) => ({ ...prev, 'monthlyDeprecation': 0.00 }));
        } else {
            let deprecation = Number(getOnlyNumbers(budgetPrice)) / Number(catalogItemValues?.leaseTerm?.label);
            if (name == "leaseTerm" && val) {
                deprecation = Number(getOnlyNumbers(catalogItemValues?.budgetingPrice)) / Number(val?.label);
            } else if (name == "budgetingPrice" && catalogItemValues?.leaseTerm?.value) {
                deprecation = Number(getOnlyNumbers(val)) / Number(catalogItemValues?.leaseTerm?.label);
            }
            setCatalogItemValues((prev: any) => ({ ...prev, 'monthlyDeprecation': (isNaN(deprecation) || !isFinite(deprecation)) ? 0.00 : formatPrice(deprecation, 2) }));
        }
    }

    const handleChange = (value: any, name: string) => {
        setCatalogItemValues((prev: any) => ({ ...prev, [name]: value }))
        validateCatalogItemValues(value, name)
        let budgetPrice: any = null
        if (name === 'actualPrice' && catalogItemValues?.budgetingPercent?.value) {
            budgetPrice = Number(getOnlyNumbers(value)) * (1 + catalogItemValues?.budgetingPercent?.label.split('%')[0]) / 100;
            setCatalogItemValues((prev: any) => ({ ...prev, 'budgetingPrice': formatPrice(budgetPrice, 2) }))
            setCatalogItemErrors((prev: any) => ({ ...prev, budgetingPrice: '' }))
        }

        if (name === 'budgetingPercent' && catalogItemValues?.actualPrice) {
            budgetPrice = Number(getOnlyNumbers(catalogItemValues?.actualPrice)) + (Number(getOnlyNumbers(catalogItemValues?.actualPrice)) * Number(value?.label.split('%')[0])) / 100
            setCatalogItemValues((prev: any) => ({ ...prev, 'budgetingPrice': formatPrice(budgetPrice, 2) }))
        }
        if (name == "leaseTerm" || name == "budgetingPrice" || name == "actualPrice" || name === 'budgetingPercent') {
            getMonthlyDeprecation(name, value, budgetPrice)
            setCatalogItemErrors((prev: any) => ({ ...prev, monthlyDeprecation: '' }))
        }
    }

    const priceFormat = (e: any, name: string) => {
        if (e.target.value == 0) {
            return
        }
        setCatalogItemValues((prev: any) => ({ ...prev, [name]: formatPrice(e.target.value, 2) }));
    };

    return (
        <BudgetInformation
            budgetingPercentOption={budgetPercentList}
            leaseTermsOption={useFulLifeList}
            logoedOption={logoedOption}
            assetTypeValue={assetTypeValue}
            catalogItemValues={catalogItemValues}
            catalogItemErrors={catalogItemErrors}
            handleChange={handleChange}
            priceFormat={priceFormat}
            getGLCode={getGLCode}
            useOption={useList}

            onPopupFilterModel={onPopupFilterModel}
        />
    )
}

export default BudgetInformationContainer;